import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8d3c28a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "MajorPageBackground" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "headerMainContainer" }
const _hoisted_4 = { id: "headerLine1" }
const _hoisted_5 = { id: "majorName" }
const _hoisted_6 = {
  key: 0,
  style: {"color":"#cd3532","margin-right":"15px"}
}
const _hoisted_7 = {
  key: 0,
  id: "headerLine3"
}
const _hoisted_8 = { id: "headerLine2" }
const _hoisted_9 = { id: "mainBody" }

import {ref, reactive} from 'vue';
  import {ElMessage} from 'element-plus';
  import {getMajorInfo, majorsGetMajorsDetailV2, masterGetCollegeName} from "@/network/axios";
  import {useRouter, useRoute} from "vue-router";
  import MajorSituation from './MajorSituation.vue'
  import MasterInfo from './MasterInfo.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MajorPage',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();

  //专科和职业本科 不显示硕士专业标签
  let masterMajorDisplay = ref(false);
  let majorCode: any = ref('');
  majorCode.value = route.params.id;
  let firstStr = majorCode.value.slice(0, 1);
  //如果第一个字是0或者1就显示，其他的一律不显示
  //第一个数字0、1是本科；2、3是职本；4、5是专科
  if (firstStr == '0' || firstStr == '1') {
    masterMajorDisplay.value = true
  } else {
    masterMajorDisplay.value = false
  }

  // ==============================================//
  //获取院校名称
  let collegeCode: any = ref('');
  collegeCode.value = route.params.collegeCode;
  let collegeName = ref('')
  masterGetCollegeName('/master/getCollegeName', {
    params: {
      collegeCode: collegeCode.value
    }
  }).then((res) => {
    if (res.data.code == 200) {
      collegeName.value = res.data.data
    }
  })

  //专业概况 硕士专业 tab
  let activeName = ref('专业概况')
  let isMajorSituation = ref(true)
  let isMasterInfo = ref(false)
  let handleClick = (tab: any) => {
    if (tab.paneName == '专业概况') {
      isMajorSituation.value = true;
      isMasterInfo.value = false;
    } else if (tab.paneName == '硕士专业') {
      isMajorSituation.value = false;
      isMasterInfo.value = true;
    }
  }
  // ==============================================//

  //本科的信息
  let majorInfo = reactive({
    //第一行专业名称
    major: '',
    //第二行 专业代码 专业年限 授予学位
    line2Str: '',
    //专业介绍
    intruduction: '',
    //详情
    details: '',
    //选考建议
    advise: {
      foundation: '',
      limitaion: '',
      demand: '',
    },
    //升学方向
    masterDir: {
      MdName: '',
      firstLevel: '',
      majorsConnection: '',
    },
    //就业方向
    orientation: '',
    //社会名人
    famous: '',
    //开设课程
    offering: '',

  });

  let getMajorInfoMethod = () => {
    getMajorInfo('/majors/getMajorsDetail', {
      params: {
        majorGroup: route.params.id,
      }
    }).then((res) => {
      if (res.data.code == '200') {
        // console.log(res.data);
        let line2Array: any = ref([]);
        majorInfo.major = res.data.data.major;
        if (res.data.data.majorCode != '') {
          line2Array.value.push('专业代码:' + res.data.data.majorCode);
        }
        if (res.data.data.duration != '') {
          line2Array.value.push('专业年限:' + res.data.data.duration);
        }
        if (res.data.data.bacherlor != '') {
          line2Array.value.push('授予学位:' + res.data.data.bacherlor);
        }
        majorInfo.line2Str = line2Array.value.join(' | ');
        majorInfo.intruduction = res.data.data.intruduction;
        majorInfo.details = res.data.data.details;
        majorInfo.advise = res.data.data.advise;
        majorInfo.masterDir = res.data.data.masterDir;
        majorInfo.orientation = res.data.data.orientation;
        majorInfo.famous = res.data.data.famous;
        majorInfo.offering = res.data.data.offering;
      } else if (res.data.data == '') {
        router.push('/TransferPage/0101');
        ElMessage({
          message: '查无此信息，页面自动跳转',
          type: 'warning',
          offset: 200,
        })
      }
    })
  };
  //如果是 本科 就走这个接口
  if (firstStr == '0' || firstStr == '1') {
    getMajorInfoMethod()
  }


  //专科、职本的信息
  let majorInfo2 = reactive({
    careerCertificateExample: {
      professionalSkillLevel: '',
      qualificationCertificate: '',
    },
    careerOriented: '',
    continuationMajor: {
      first: '',
      second: '',
    },
    cultivateTarget: '',
    duration: '',
    mainClass: {
      basicCourses: '',
      coreCourses: '',
      internshipTraining: '',
    },
    mainProfessional: '',
    majorCode: '',
    majors: '',
    teachStandard: '',
  });


  let getMajorInfoMethodV2 = () => {
    majorsGetMajorsDetailV2('/majors/getMajorsDetailV2', {
      params: {
        majorGroup: route.params.id,
      }
    }).then((res) => {
      if (res.data) {
        let line2Array: any = ref([]);
        majorInfo.major = res.data.data.majors;
        if (res.data.data.majorCode != '') {
          line2Array.value.push('专业代码:' + res.data.data.majorCode);
        }
        if (res.data.data.duration != '') {
          line2Array.value.push('专业年限:' + res.data.data.duration);
        }
        if (res.data.data.bacherlor != '') {
          line2Array.value.push('授予学位:' + res.data.data.bacherlor);
        }




        majorInfo.line2Str = line2Array.value.join(' | ');


        majorInfo2.careerCertificateExample.professionalSkillLevel = res.data.data.careerCertificateExample.professionalSkillLevel;
        majorInfo2.careerCertificateExample.qualificationCertificate = res.data.data.careerCertificateExample.qualificationCertificate;
        majorInfo2.careerOriented = res.data.data.careerOriented;
        majorInfo2.continuationMajor.first = res.data.data.continuationMajor.first;
        majorInfo2.continuationMajor.second = res.data.data.continuationMajor.second;
        majorInfo2.cultivateTarget = res.data.data.cultivateTarget;
        majorInfo2.duration = res.data.data.duration;
        majorInfo2.mainClass.basicCourses = res.data.data.mainClass.basicCourses;
        majorInfo2.mainClass.coreCourses = res.data.data.mainClass.coreCourses;
        majorInfo2.mainClass.internshipTraining = res.data.data.mainClass.internshipTraining;
        majorInfo2.mainProfessional = res.data.data.mainProfessional;
        majorInfo2.majorCode = res.data.data.majorCode;
        majorInfo2.majors = res.data.data.majors;
        majorInfo2.teachStandard = res.data.data.teachStandard;
      }
    })
  }

  //如果是 职业本科和专科 就走这个接口
  if (firstStr == '2' || firstStr == '3' || firstStr == '4' || firstStr == '5') {
    getMajorInfoMethodV2()
  }



return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(collegeName))
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(collegeName)), 1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_unref(majorInfo).major), 1)
          ])
        ]),
        (_unref(majorInfo2).teachStandard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_link, {
                type: "danger",
                href: _unref(majorInfo2).teachStandard,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("点击查看专业教学标准-教育部2025年修（制）订")
                ]),
                _: 1
              }, 8, ["href"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(majorInfo).line2Str), 1)
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(activeName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : activeName = $event)),
        class: "bigElTabs",
        onTabClick: _unref(handleClick)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "专业概况",
            name: "专业概况"
          }),
          (_unref(masterMajorDisplay))
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: "硕士专业",
                name: "硕士专业"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_unref(isMajorSituation))
        ? (_openBlock(), _createBlock(MajorSituation, {
            key: 0,
            majorInfo: _unref(majorInfo),
            majorInfo2: _unref(majorInfo2),
            firstStr: _unref(firstStr)
          }, null, 8, ["majorInfo", "majorInfo2", "firstStr"]))
        : _createCommentVNode("", true),
      (_unref(isMasterInfo))
        ? (_openBlock(), _createBlock(MasterInfo, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})